var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({attrs:{"disabled":_vm.$props.disabled || _vm.uiFrozen,"elevation":1,"loading":_vm.waitingForCode},on:{"click":_vm.click,"contextmenu":function($event){return _vm.$emit('contextmenu', $event)}}},'v-btn',_vm.$props,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }